<template>
	<div class="content-box">
		<div class="banner">
			<div class="banner_title">
				<div class="big">
					漏洞列表
				</div>
				<div class="min">
					检查你关心的漏洞信息
				</div>
			</div>
			<!-- <div class="banner-img">
				<img src="../../assets/image/banner/bug_icon.png" />
			</div> -->
		</div>
		<div class="mainWidth">
			<div style="width: 830px;">
				<!-- search -->
				<div class="search_info">
					<div class="s_total">
						总共有 <span>{{total}}</span> 条漏洞
					</div>
					<div class="s_input">
						<a-input placeholder="请输入关键词" v-model="titleLike" style="width: 182px;height: 30px;" />
						<a-button type="primary" size="small" style="height: 30px;padding: 0 10px;" @click="search">搜索</a-button>
					</div>
				</div>
				<!-- hr -->
				<div style="width: 830px;height: 2px;background-color: #009ef3;"></div>
				<!-- tiaojian -->
				<div class="condition">
					<div style="display: flex;justify-content: flex-start;align-items: center;height: 30px;margin-bottom: 15px;">
						<div class="tj_t">
							危害等级：
						</div>
						<div>
							<span class="list_top_info" v-for="(item,i) in this.lowLeve" :key="i" v-bind:class="{active:i==lowIndex}" @click="lowClick(i,item.value)">{{item.title}}</span>
						</div>
					</div>
					<div style="display: flex;justify-content: flex-start;align-items: center;height: 30px;">
						<div class="tj_t">
							时间：
						</div>
						<div>
							<span class="list_top_info" v-for="(item,i) in this.timeArr" :key="i" v-bind:class="{active:i==timeIndex}"
							 @click="timeClick(i,item.value)">{{item.title}}</span>
						</div>
					</div>
				</div>
				<!-- table -->
				<div class="table-box">
					<a-table :columns="columns" :data-source="data" rowKey="id" :pagination="false">
						<a slot="tableTitle" slot-scope="text,record" style="color: #2978c3" @click="pushPath(record.id)">{{ text }}</a>
						<span slot="grade" slot-scope="text, record">
							<img v-if="text == '高危'" src="../../assets/image/icon/high.png" style="width: 28px;height: 4px;margin-right: 12px;" />
							<img v-if="text == '中危'" src="../../assets/image/icon/middle.png" style="width: 28px;height: 4px;margin-right: 12px;" />
							<img v-if="text == '低危'" src="../../assets/image/icon/low.png" style="width: 28px;height: 4px;margin-right: 12px;" />
							{{ text }}
						</span>
					</a-table>
				</div>

				<a-pagination style="margin:18px 0 95px;text-align: right;" :default-current="1" :total="total" @change="pageFun" />
			</div>

			<div style="width: 350px;">
				<div @click="See" style="cursor: pointer;border-radius: 4px;width: 350px;height: 46px;background-color: #f34f4e;line-height: 46px;margin: 30px 0 20px;color: #fff;font-size: 16px;">
					<img src="../../assets/image/icon/submit.png" style="width: 19px;height: 26px;margin-right: 10px;" />
					漏洞提交
					<!-- <img src="../../assets/image/bug_submit_big.png" alt="" @click="See"> -->
				</div>
				<div style="text-align: left;">
					<img src="../../assets/image/icon/hot.png" style="width: 12px;height: 14px;display: inline-block;margin-right: 8px;" />
					<p style="display: inline-block;font-family: PingFangSC-Medium;font-size: 14px;font-weight: normal;font-stretch: normal;line-height: 13px;letter-spacing: 0px;color: #181818;margin-bottom: 15px;">热门漏洞</p>
				</div>
				<a-row style="padding: 0 27px 20px 23px;border-radius: 3px;background: #fafafa;" class="rightBoxMsg">
					<a-col>
						<a-row>
							<p style="cursor: pointer;text-align: left;height: 50px;font-size: 14px;line-height: 50px;font-weight: 400;color: #999;border-bottom: 1px dashed #ccc;margin-bottom:0px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
							 v-for="(item,i) in this.hotInfo" :data-id="item.id" @click="pushPath(item.id)" :key="i">
								<a-icon type="caret-right" style="margin-right: 3px" />
								<span class="listLi">{{item.title}}</span>
							</p>

						</a-row>
					</a-col>
				</a-row>

			</div>

		</div>

	</div>
</template>

<script>
	import {
		getHotBug,
		getBugInfo
	} from '../../api/index'
	import {
		getList
	} from '../../api/bugList'
	const columns = [

		{
			title: '公开日期',
			dataIndex: 'publicDate',
			key: 'publicDate',
			width: 100,

		},
		{
			title: '漏洞标题',
			dataIndex: 'title',
			key: 'title',
			width: 400,
			scopedSlots: {
				customRender: 'tableTitle'
			},
		},
		{
			title: '危害等级',
			dataIndex: 'grade',
			key: 'grade',
			width: 90,
			ellipsis: true,
			scopedSlots: {
				customRender: 'grade'
			},
		},
		{
			title: '点击数',
			dataIndex: 'count',
			key: 'count',
			ellipsis: true,
			width: 80,
		},
	];
	const data = [

	];
	export default {
		name: "bugList",
		data() {
			return {
				// 漏洞等级
				vulLevel: {
					3: '高危',
					2: '中危',
					1: '低危',
					// 0 : '未知'
				},
				data,
				columns,
				//搜索输入框
				titleLike: null,
				//影响类型
				objectType: [{
						title: '全部',
						value: ''
					},
					// {
					//     title:'区块链',value:1
					// },
					// {
					//     title:'车联网',value:2
					// },
					{
						title: '工控系统',
						value: 3
					}
				],
				nowIndex: 0,
				typeValue: null,
				//风险等级
				lowLeve: [{
						title: '全部',
						value: ''
					},
					{
						title: '高危',
						value: 3
					},
					{
						title: '中危',
						value: 2
					},
					{
						title: '低危',
						value: 1
					},
					// {
					//     title:'未知',value:0
					// },
				],
				lowIndex: 0,
				lowValue: null,
				//时间
				timeArr: [{
						title: '全部',
						value: ''
					},
					{
						title: '今天',
						value: 'day'
					},
					{
						title: '一周内',
						value: 'week'
					},
					{
						title: '一个月内',
						value: 'month'
					},
					{
						title: '半年内',
						value: 'halfYear'
					},
				],
				timeIndex: 0,
				timeValue: null,
				period: null,
				//分页
				current: null,
				//总数
				total: null,
				//热门漏洞
				hotInfo: [],
				//点击切换选中状态
				nowIndex: 0
			}
		},
		methods: {
			//跳转提交
			See(e) {
				window.location.href = 'https://www.cnvd.org.cn/user/login'
			},
			//输入框搜索
			search() {
				this.getlist()
			},
			//获取列表
			getlist() {
				if (this.titleLike == '' || this.titleLike == undefined) {
					var params = {
						vulClass: this.typeValue,
						grade: this.lowValue,
						period: this.period,
						pageSize: 10,
						pageNo: 1
					}
				} else {
					var params = {
						title: this.titleLike,
						titleLike: 'ALL',
						vulClass: this.typeValue,
						grade: this.lowValue,
						period: this.period,
						pageSize: 10,
						pageNo: 1
					}
				}
				getList(params).then(res => {
					if (res.status == 200) {
						if (JSON.stringify(res.data.page.records) == '{}') {
							this.data = []
							this.total = 0
						} else {
							var num = JSON.parse(res.data.page.total)
							var data = res.data.page.records
							this.total = num
							for (var i = 0; i < data.length; i++) {
								data[i].publicDate = data[i].publicDate.split(' ')[0] // 切割时间的时分秒
								data[i].grade = this.vulLevel[data[i].grade]
							}
							this.data = data
						}
					} else if (res.status == 504) {
						this.$message.warning(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
				})
			},
			// 分页
			pageFun(page, pageSize) {
				var params = {
					pageSize: 10,
					pageNo: page,
					vulClass: this.typeValue,
					grade: this.lowValue,
					period: this.period,
				}
				if (this.titleLike == '' || this.titleLike == undefined) {
					var params = {
						pageSize: 10,
						pageNo: page,
						vulClass: this.typeValue,
						grade: this.lowValue,
						period: this.period,
					}
				} else {
					var params = {
						title: this.titleLike,
						titleLike: 'ALL',
						pageSize: 10,
						pageNo: page,
						vulClass: this.typeValue,
						grade: this.lowValue,
						period: this.period,
					}
				}

				getList(params).then(res => {
					if (res.status == 200) {
						var num = JSON.parse(res.data.page.total)
						var data = res.data.page.records
						for (var i = 0; i < data.length; i++) {
							data[i].publicDate = data[i].publicDate.split(' ')[0] // 切割时间的时分秒
							data[i].grade = this.vulLevel[data[i].grade]
						}
						this.data = data
					} else if (res.status == 504) {
						this.$message.warning(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
				})
			},
			// 影响对象点击
			objectClick(index, value) {
				this.nowIndex = index;
				this.typeValue = value;
				this.getlist()
			},
			// 风险等级点击
			lowClick(index, value) {
				this.lowIndex = index;
				this.lowValue = value
				this.getlist()
			},
			//  时间点击
			timeClick(index, value) {
				this.timeIndex = index;
				this.period = value
				this.getlist()
			},
			// 获取热门漏洞
			getHot() {
				getHotBug().then(res => {
					if (res.status == 200) {
						this.hotInfo = res.data.page.records
					} else if (res.status == 504) {
						this.$message.warning(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
				})
			},
			// 跳转漏洞详情
			pushPath(id) {
				this.$router.push({
					name: 'bugInfo',
					params: {
						key: id
					}
				})
			},
		},
		created() {
			this.getHot()
			if (this.$route.params.i) {
				this.lowClick(this.$route.params.i, this.$route.params.value)
			} else {
				this.getlist();
			}
		}
	}
</script>

<style scoped>
	.content-box {
		width: 100%;
		background-color: #ffffff;
	}

	.banner {
		width: 100%;
		height: 290px;
		background: url("../../assets/image/banner/bug_new.png") center center no-repeat;
		background-size: cover;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.banner_title {
		width: 300px;
		height: 117px;
		background-color: rgba(6, 77, 166, 0.3);
		/* background-color: #064da6; */
		/* opacity: 0.3; */
		text-align: center;
	}
	
	.big {
		height: 36px;
		font-family: MicrosoftYaHei-Bold;
		font-size: 36px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 13px;
		letter-spacing: 4px;
		margin-top: 35px;
		color: #fefefe;
		/* box-shadow: 0px 1px 0px 0px 
				rgba(41, 47, 49, 0.39); */
	}
	
	.min {
		height: 14px;
		font-family: PingFangSC-Semibold;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 13px;
		letter-spacing: 1px;
		color: #f4f1f1;
		margin-top: 10px;
		z-index: 999;
		/* box-shadow: 0px 1px 0px 0px 
					rgba(41, 47, 49, 0.39); */
	}

	.banner-img {
		margin: 0 auto;
		width: 14%;
		display: flex;
		align-items: center;
		height: 290px;
		/* height: 100px; */
	}

	.banner-img img {
		width: 100%;
		height: auto;
		align-items: center;
	}

	/* .banner{
        width: 100%;
    }
    .banner img{
        width: 100%;
        height: auto;
    } */
	p {
		margin-bottom: 0px;
	}

	img,
	ul,
	li {
		width: 100%;
		list-style: none;
	}

	.left_top {
		display: flex;
		border: 1px solid #0f0;
		height: 50px;
	}

	.list_top_type {
		width: 100px;
		display: inline-block;
		text-align: right;
		font-size: 14px;
		font-weight: 700;
		line-height: 14px;
		color: #333;
		margin-right: 7px;
	}

	.list_top_info {
		height: 14px;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 30px;
		letter-spacing: 1px;
		color: #0d1a26;
		cursor: pointer;
		margin-right: 30px;
	}

	.active {
		display: inline-block;
		width: 62px;
		height: 30px;
		background-color: #009df7;
		border-radius: 2px;
		border: solid 1px #009df7;
		color: #fff;
		/* color: #2978c3 !important; */
	}

	.list_top_info:hover {
		text-decoration: underline;
	}

	/deep/ .ant-table-thead>tr>th {
		border-bottom: 1px solid #ebeef5;
		border-top: 1px solid #ebeef5;
		font-weight: 700;
		background-color: #f2f2f2;
	}

	/deep/ .ant-table-tbody>tr:nth-child(even)>td {
		background: #fafafa;

	}

	.listLi:hover {
		color: #2978c3;
	}

	.total {
		text-align: left;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 13px;
		letter-spacing: 0px;
		color: #999999;
		width: 50%;
	}

	.total span {
		font-family: PingFangSC-Regular;
		font-size: 14px;
		font-weight: normal;
		letter-spacing: 0px;
		color: #009ef3;
	}

	.mainWidth {
		display: flex;
		justify-content: space-between;
	}

	.search_info {
		width: 100%;
		height: 30px;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
		margin: 30px 0 20px;
	}

	.s_total {
		width: 50%;
		height: 14px;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 13px;
		letter-spacing: 0px;
		color: #999999;
		text-align: left;
	}

	.s_total span {
		font-family: PingFangSC-Regular;
		font-size: 14px;
		font-weight: normal;
		letter-spacing: 0px;
		color: #009ef3;
	}

	.s_input {
		width: 50%;
		text-align: right;
	}

	.condition {
		width: 830px;
		height: 110px;
		border: solid 1px #f3f2f2;
		padding: 25px 0;
		margin-bottom: 20px;
	}

	.tj_t {
		width: 80px;
		height: 14px;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 16px;
		letter-spacing: 1px;
		color: #0d1a26;
		text-align: right;
		margin-left: 20px;
	}

	.table-box {
		width: 100%;
		/* height: 500px; */
	}

	/* /deep/ .ant-table-thead>tr>th,
	.ant-table-tbody>tr>td {
		padding: 0px !important;
		height: 40px !important;
	} */
</style>
